import type { ReactNode } from 'react';

import Colors from '@rockalingua/ui/constants/Colors';

import Text from '../Typography/Text';
import {
  Container,
  FeatureItem as StyledFeatureItem,
  IconContainer,
} from './FeatureGrid.styled';

type FeatureGridProps = {
  items: FeatureGridItem[];
};

export default function FeatureGrid({ items }: FeatureGridProps) {
  return (
    <Container>
      {items.map((item) => (
        <StyledFeatureItem key={item.title}>
          <IconContainer $backgroundColor={item.iconBackgroundColor}>
            {item.icon}
          </IconContainer>
          <Text variant={titleVariant} color={Colors.BLACK}>
            {item.title}
          </Text>
          <Text variant={descriptionVariant} color={Colors.BLACK}>
            {item.description}
          </Text>
        </StyledFeatureItem>
      ))}
    </Container>
  );
}

export type FeatureGridItem = {
  icon: ReactNode;
  iconBackgroundColor: string;
  title: string;
  description: string | ReactNode;
};

const titleVariant = 'title-mid-grey-32';
const descriptionVariant = 'grey-16-medium';

export type { FeatureGridProps };
